const SCHEME_SEPARATOR = "://";
const SECURE_WS_PREFIX = "wss" + SCHEME_SEPARATOR;

/**
 * Converts an HTTP(S) or legacy WS API base URL to a secure WebSocket ActionCable URL.
 * Never returns an unencrypted WebSocket URL (always wss).
 */
export function toSecureWebSocketCableUrl(
  baseUrl: string,
  token?: string,
): string {
  let wsUrl = baseUrl.trim();
  const sepIndex = wsUrl.indexOf(SCHEME_SEPARATOR);

  if (sepIndex > 0) {
    const scheme = wsUrl.slice(0, sepIndex).toLowerCase();
    const rest = wsUrl.slice(sepIndex + SCHEME_SEPARATOR.length);

    if (scheme === "https" || scheme === "http" || scheme === "ws") {
      wsUrl = SECURE_WS_PREFIX + rest;
    }
  } else {
    wsUrl = SECURE_WS_PREFIX + wsUrl.replace(/^\/+/, "");
  }

  if (!wsUrl.endsWith("/cable")) {
    wsUrl = wsUrl.replace(/\/$/, "") + "/cable";
  }

  if (token) {
    const separator = wsUrl.includes("?") ? "&" : "?";
    wsUrl = `${wsUrl}${separator}token=${encodeURIComponent(token)}`;
  }

  return wsUrl;
}
